import type { Translations } from '../../types'

const navMessages: Translations = {
  "nav.groups.overview": "Panoramica",
  "nav.groups.overviewCenter": "Panoramica",
  "nav.groups.core": "Core",
  "nav.groups.commerce": "Commerce",
  "nav.groups.catalog": "Catalogo",
  "nav.groups.orders": "Ordini",
  "nav.groups.customers": "Clienti",
  "nav.groups.personalization": "Personalizzazione",
  "nav.groups.shop": "Shop",
  "nav.groups.content": "Contenuti",
  "nav.groups.communications": "Comunicazioni",
  "nav.groups.system": "Sistema",
  "nav.groups.account": "Account",
  "nav.groups.security": "Sicurezza",
  "nav.groups.team": "Team",
  "nav.groups.dangerZone": "Zona pericolosa",
  "nav.groups.operations": "Operations",
  "nav.groups.extensions": "Estensioni",
  "nav.groups.siteSettings": "Site settings",
  "nav.groups.customerAccount": "Profilo cliente",
  "nav.items.dashboard": "Dashboard",
  "nav.items.activity": "Attività",
  "nav.items.platformStatus": "Stato piattaforma",
  "nav.items.supportRequests": "Richieste assistenza",
  "nav.items.supportInbox": "Ticket assistenza",
  "nav.items.notifications": "Notifiche",
  "nav.items.slider": "Slider Hero",
  "nav.items.media": "Media",
  "nav.items.pages": "Pagine",
  "nav.items.plugins": "Plugin",
  "nav.items.languages": "Lingue",
  "nav.items.siteSettings": "Site settings",
  "nav.items.site.branding": "Homepage",
  "nav.items.site.homepage": "Homepage",
  "nav.items.themes": "Theme manager",
  "nav.items.site.footer": "Footer",
  "nav.items.site.legal": "Privacy e policy",
  "nav.items.site.contact": "Contatti e social",
  "nav.items.site.emailSettings": "Configurazione email",
  "nav.items.site.emailTemplates": "Template email",
  "nav.items.site.emailLogs": "Automazioni e log",
  "nav.items.site.botProtection": "Protezione bot",
  "nav.items.site.payments": "Pagamenti",
  "nav.items.inventory": "Inventario",
  "nav.items.systemStatus": "Stato sistemi",
  "nav.items.updates": "Aggiornamenti piattaforma",
  "nav.items.featureFlags": "Feature Flags",
  "nav.items.auditLogs": "Audit log",
  "nav.items.auditTrail": "Timeline attività",
  "nav.items.builder": "Compositore contenuti",
  "nav.items.menu": "Menu homepage",
  "nav.items.shop.products": "Prodotti",
  "nav.items.shop.categories": "Categorie",
  "nav.items.shop.orders": "Ordini",
  "nav.items.customer.ordersInvoices": "I miei ordini e fatture",
  "nav.items.customer.profile": "Profilo",
  "nav.items.customer.addresses": "Indirizzi",
  "nav.items.shop.customers": "Clienti",
  "nav.items.shop.migrations": "Migrazioni dati",
  "nav.items.shop.productTypes": "Modelli prodotto",
  "nav.items.profile.contact": "Profilo",
  "nav.items.profile.preferences": "Preferenze",
  "nav.items.profile.smtp": "Infrastruttura email",
  "nav.items.profile.security": "Sicurezza account",
  "nav.items.profile.sessions": "Sessioni",
  "nav.items.profile.team": "Accessi team",
  "nav.items.profile.danger": "Privacy"
}

export default navMessages
